export const VERTICAL_LINKS = [
  { label: 'Hotels & Resorts', path: '/hotels' },
  { label: 'Co-working Spaces', path: '/co-working' },
  { label: 'Clinics & Hospitals', path: '/healthcare' },
  { label: 'Corporate Offices', path: '/corporate' },
  { label: 'Events & Venues', path: '/events' },
  { label: 'Banks & NBFCs', path: '/banking' },
  { label: 'Gated Communities', path: '/gated-communities' },
  { label: 'Govt / Jan Seva Kendra', path: '/jan-seva-kendra' },
  { label: 'Gyms & Fitness', path: '/gyms' },
  { label: 'Coaching Institutes', path: '/coaching' },
  { label: 'Schools & Colleges', path: '/schools' },
  { label: 'Hostels & PGs', path: '/hostels' },
  { label: 'Retail & Malls', path: '/retail' },
  { label: 'Religious Trusts', path: '/religious-trusts' },
  { label: 'Logistics & Warehouses', path: '/logistics' },
];
